import { CustomSelect } from '../../vendors/custom-slect'
import { validEmail } from '../../common/validate'

const fullForm = () => {
  const formSelectElements = document.querySelectorAll('.full-form-select-grade')
  for (const element of formSelectElements) {
    const selectGrade = new CustomSelect(element)
  }

  const btn = document.querySelectorAll('.submit-full-form')

  for (let i = 0; i < btn.length; i++) {
    btn[i].addEventListener('click', function (e) {
      e.preventDefault()

      const parent = this.parentElement
      const formEmailBox = parent.querySelector('.full-form-box__field.email .field-border')
      const formMessage = parent.querySelector('.full-form-box__field.email .message-success')
      const formEmail = parent.querySelector('.email-full-form').value
      const formSelectButton = parent.querySelector('.select__toggle')
      const formFullGrade = formSelectButton.value
      const formSelectElement = parent.querySelector('.full-form-select-grade .field-border')
      const isValidEmail = validEmail(formEmail)
      const submitUtm = btn[i].getAttribute('data-text')

      if (formFullGrade) {
        formSelectElement.classList.remove('error')
        formSelectElement.classList.add('valid')
      } else {
        formSelectElement.classList.remove('valid')
        formSelectElement.classList.add('error')
      }

      if (isValidEmail) {
        formEmailBox.classList.remove('error')
        formEmailBox.classList.add('valid')
      } else {
        formEmailBox.classList.remove('valid')
        formEmailBox.classList.add('error')
      }

      if (formFullGrade && isValidEmail) {
        // validation
        formMessage.classList.add('active')
        btn[i].setAttribute('disabled', 'disabled')

        const appUrl = parent.querySelector('.full-form-box__url').value
        let params = new URLSearchParams(window.location.search).toString()
        params = params.length > 0 ? '&' + params : ''

        window.location.href = `${appUrl}?email=${formEmail}&grade=${formFullGrade}&${submitUtm}` + params
      }
    })
  }
}
export default fullForm
